// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContactSupport_support_link__DwP0x {\n  color: var(--color-primary);\n}\n", "",{"version":3,"sources":["webpack://src/common/components/ContactSupport/ContactSupport.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B","sourcesContent":[".support_link {\n  color: var(--color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"support_link": "ContactSupport_support_link__DwP0x"
};
export default ___CSS_LOADER_EXPORT___;
